import { createBrowserRouter } from "react-router";
import AuthRoot from "./components/AuthRoot";
import Root from "./pages/Root";
import StyleGuide from "./pages/StyleGuide";
import ComponentLibrary from "./pages/ComponentLibrary";
import ComponentDemo from "./pages/ComponentDemo";
import Calendar from "./pages/Calendar";
import DaySheet from "./pages/DaySheet";
import EventsList from "./pages/EventsList";
import EventDetail from "./pages/EventDetail";
import PartnersDirectory from "./pages/PartnersDirectory";
import PartnerDetail from "./pages/PartnerDetail";
import SponsorsDirectory from "./pages/SponsorsDirectory";
// #104/#105 — About Us page kept dark for launch; re-enable when final copy lands.
// import About from "./pages/About";
import Contact from "./pages/Contact";
import Account from "./pages/Account";
import MagicLinkVerify from "./pages/MagicLinkVerify";
import MyEvents from "./pages/MyEvents";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import CookiePolicy from "./pages/CookiePolicy";
import DeletionStatus from "./pages/DeletionStatus";
import StaffLogin from "./pages/staff/StaffLogin";
import ForgotPassword from "./pages/staff/ForgotPassword";
import ResetPassword from "./pages/staff/ResetPassword";
import ProtectedStaffLayout from "./components/ProtectedStaffLayout";
import StaffHome from "./pages/staff/StaffHome";
import ManageActivities from "./pages/staff/ManageActivities";
import ActivityForm from "./pages/staff/ActivityForm";
import ManagePartners from "./pages/staff/ManagePartners";
import ManageSponsors from "./pages/staff/ManageSponsors";
import ManageTags from "./pages/staff/ManageTags";
import ManageTeams from "./pages/staff/ManageTeams";
import ManageUsers from "./pages/staff/ManageUsers";
import AuditLog from "./pages/staff/AuditLog";
import PartnerActivities from "./pages/staff/PartnerActivities";
import MyPartners from "./pages/staff/MyPartners";
import ChangePassword from "./pages/staff/ChangePassword";
import PartnerDpa from "./pages/staff/PartnerDpa";
import ActivityParticipants from "./pages/staff/ActivityParticipants";
import ActivityVolunteers from "./pages/staff/ActivityVolunteers";
import ActivityInvitations from "./pages/staff/ActivityInvitations";
import InvitationResponse from "./pages/InvitationResponse";
import DocsIndex from "./pages/staff/docs/DocsIndex";
import DocActivitati from "./pages/staff/docs/DocActivitati";
import DocParticipanti from "./pages/staff/docs/DocParticipanti";
import DocParteneri from "./pages/staff/docs/DocParteneri";
import DocTaguri from "./pages/staff/docs/DocTaguri";
import DocEchipe from "./pages/staff/docs/DocEchipe";
import DocUtilizatori from "./pages/staff/docs/DocUtilizatori";
import DocJurnal from "./pages/staff/docs/DocJurnal";
import DocActivitatileMele from "./pages/staff/docs/DocActivitatileMele";
import DocOrganizatiileMele from "./pages/staff/docs/DocOrganizatiileMele";
import DocDpa from "./pages/staff/docs/DocDpa";
import DocMarkdown from "./pages/staff/docs/DocMarkdown";
import DocVoluntari from "./pages/staff/docs/DocVoluntari";
import DocInvitatii from "./pages/staff/docs/DocInvitatii";
import ErrorPage from "./pages/ErrorPage";

export const router = createBrowserRouter([
  {
    Component: AuthRoot,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/",
        Component: Root,
        errorElement: <ErrorPage />,
        children: [
          { index: true, Component: EventsList },
          { path: "style-guide", Component: StyleGuide },
          { path: "componente", Component: ComponentLibrary },
          { path: "demo", Component: ComponentDemo },

          // Public area
          { path: "calendar", Component: Calendar },
          { path: "zi/:date", Component: DaySheet },
          { path: "evenimente", Component: EventsList },
          { path: "eveniment/:slug", Component: EventDetail },
          { path: "parteneri", Component: PartnersDirectory },
          { path: "partener/:slug", Component: PartnerDetail },
          { path: "parteneri-sponsori", Component: SponsorsDirectory },
          // #104/#105 — About Us route kept dark for launch; re-enable with the import above.
          // { path: "despre-noi", Component: About },
          { path: "contact", Component: Contact },
          { path: "cont", Component: Account },
          { path: "auth/magic-link/:uid/:token", Component: MagicLinkVerify },
          { path: "cont/evenimente", Component: MyEvents },
          { path: "invitatie/:token", Component: InvitationResponse },
          { path: "confidentialitate", Component: PrivacyPolicy },
          { path: "termeni", Component: TermsConditions },
          { path: "cookies", Component: CookiePolicy },
          { path: "stergere-date/:code", Component: DeletionStatus },
        ],
      },
      // Staff login (no layout)
      { path: "/staff/login", Component: StaffLogin },
      { path: "/staff/parola-uitata", Component: ForgotPassword },
      { path: "/staff/reseteaza-parola/:uid/:token", Component: ResetPassword },
      { path: "/staff/seteaza-parola/:uid/:token", Component: ResetPassword },
      // Staff area (own layout, protected)
      {
        path: "/staff",
        Component: ProtectedStaffLayout,
        errorElement: <ErrorPage />,
        children: [
          { index: true, Component: StaffHome },
          { path: "activitati", Component: ManageActivities },
          { path: "activitati/nou", Component: ActivityForm },
          { path: "activitati/:id", Component: ActivityForm },
          { path: "activitati/:slug/participanti", Component: ActivityParticipants },
          { path: "activitati/:slug/voluntari", Component: ActivityVolunteers },
          { path: "activitati/:slug/invitatii", Component: ActivityInvitations },
          { path: "parteneri", Component: ManagePartners },
          { path: "parteneri-sponsori", Component: ManageSponsors },
          { path: "parteneri/nou", Component: ActivityForm }, // TODO: Create PartnerForm
          { path: "parteneri/:id", Component: ActivityForm }, // TODO: Create PartnerForm
          { path: "taguri", Component: ManageTags },
          { path: "echipe", Component: ManageTeams },
          { path: "utilizatori", Component: ManageUsers },
          { path: "jurnal", Component: AuditLog },
          { path: "activitatile-mele", Component: PartnerActivities },
          { path: "activitatile-mele/nou", Component: ActivityForm },
          { path: "activitatile-mele/:id", Component: ActivityForm },
          { path: "activitatile-mele/:slug/participanti", Component: ActivityParticipants },
          { path: "organizatiile-mele", Component: MyPartners },
          { path: "dpa/:id", Component: PartnerDpa },
          { path: "schimba-parola", Component: ChangePassword },
          { path: "documentatie", Component: DocsIndex },
          { path: "documentatie/activitati", Component: DocActivitati },
          { path: "documentatie/participanti", Component: DocParticipanti },
          { path: "documentatie/parteneri", Component: DocParteneri },
          { path: "documentatie/taguri", Component: DocTaguri },
          { path: "documentatie/echipe", Component: DocEchipe },
          { path: "documentatie/utilizatori", Component: DocUtilizatori },
          { path: "documentatie/jurnal", Component: DocJurnal },
          { path: "documentatie/activitatile-mele", Component: DocActivitatileMele },
          { path: "documentatie/organizatiile-mele", Component: DocOrganizatiileMele },
          { path: "documentatie/dpa", Component: DocDpa },
          { path: "documentatie/markdown", Component: DocMarkdown },
          { path: "documentatie/voluntari", Component: DocVoluntari },
          { path: "documentatie/invitatii", Component: DocInvitatii },
        ],
      },
    ],
  },
]);
